import mensajeError from "../../mensajes/MensajeError";
import validarEmail from "../../datos/validarEmail";
import actualizarDireccion  from "../direccion/actualizar";

export default async function actualizarContribuyente(data) {
    const { contribuyente, direcciones } = data;
    const [direccion] = direcciones;
    const settings = {
        method: "PUT",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(contribuyente)
    }

    try {
        if (contribuyente.tipoPersona === 1) {
            contribuyente.apellidoPaterno = "";
            contribuyente.apellidoMaterno = "";
        }
        if (contribuyente.mail !== "") {
            const resultado = validarEmail(contribuyente.mail);
            if (resultado === null) {
                throw new Error("Correo inválido");
            }
            else {
                await fetch("/api/contribuyente/actualizar", settings);
                await actualizarDireccion(direccion);
            }
        }
        else {
            await fetch("/api/contribuyente/actualizar", settings);
            await actualizarDireccion(direccion);
        }
    }
    catch (err) {
        mensajeError(err.message, 2000);
    }
}